<template>
  <svg width="16" height="17" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path :d="'M7.04759 10.3333H9.71425V8.33325L13.0476 11.3333L9.71425 14.3333V12.3333H7.04759V10.3333ZM6.' +
             '38092 4.99992H10.0476L6.38092 1.33325V4.99992ZM1.71425 0.333252H7.04759L11.0476 4.33325V7.22659C10.62' +
             '76 7.07992 10.1809 6.99992 9.71425 6.99992C8.65339 6.99992 7.63597 7.42135 6.88583 8.17149C6.13568 8.' +
             '92164 5.71425 9.93905 5.71425 10.9999C5.71425 12.0266 6.10092 12.9599 6.73425 13.6666H1.71425C1.36063' +
             ' 13.6666 1.02149 13.5261 0.771445 13.2761C0.521396 13.026 0.38092 12.6869 0.38092 12.3333V1.66659C0.3' +
             '8092 1.31296 0.521396 0.973825 0.771445 0.723776C1.02149 0.473728 1.36063 0.333252 1.71425 0.333252Z'"
          fill="#777777"/>
  </svg>
</template>
<script>
export default {
  name: 'IconeJuntarDocumento'
}
</script>